import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE1Items = getItem('FE1', 'FE1', <FolderOutlined />, [
  getItem('Boss Music Editor', 'FE1/BossMusicEditor'),
  getItem('Chapter 10 Unit Deployment Editor', 'FE1/Chapter10UnitDeploymentEditor'),
  getItem('Chapter 11 Unit Deployment Editor', 'FE1/Chapter11UnitDeploymentEditor'),
  getItem('Chapter 12 Unit Deployment Editor', 'FE1/Chapter12UnitDeploymentEditor'),
  getItem('Chapter 13 Unit Deployment Editor', 'FE1/Chapter13UnitDeploymentEditor'),
  getItem('Chapter 14 Unit Deployment Editor', 'FE1/Chapter14UnitDeploymentEditor'),
  getItem('Chapter 15 Unit Deployment Editor', 'FE1/Chapter15UnitDeploymentEditor'),
  getItem('Chapter 16 Unit Deployment Editor', 'FE1/Chapter16UnitDeploymentEditor'),
  getItem('Chapter 17 Unit Deployment Editor', 'FE1/Chapter17UnitDeploymentEditor'),
  getItem('Chapter 18 Unit Deployment Editor', 'FE1/Chapter18UnitDeploymentEditor'),
  getItem('Chapter 19 Unit Deployment Editor', 'FE1/Chapter19UnitDeploymentEditor'),
  getItem('Chapter 2 Unit Deployment Editor', 'FE1/Chapter2UnitDeploymentEditor'),
  getItem('Chapter 20 Unit Deployment Editor', 'FE1/Chapter20UnitDeploymentEditor'),
  getItem('Chapter 21 Unit Deployment Editor', 'FE1/Chapter21UnitDeploymentEditor'),
  getItem('Chapter 22 Unit Deployment Editor', 'FE1/Chapter22UnitDeploymentEditor'),
  getItem('Chapter 23 Unit Deployment Editor', 'FE1/Chapter23UnitDeploymentEditor'),
  getItem('Chapter 24 Unit Deployment Editor', 'FE1/Chapter24UnitDeploymentEditor'),
  getItem('Chapter 25 Unit Deployment Editor', 'FE1/Chapter25UnitDeploymentEditor'),
  getItem('Chapter 3 Unit Deployment Editor', 'FE1/Chapter3UnitDeploymentEditor'),
  getItem('Chapter 4 Unit Deployment Editor', 'FE1/Chapter4UnitDeploymentEditor'),
  getItem('Chapter 5 Unit Deployment Editor', 'FE1/Chapter5UnitDeploymentEditor'),
  getItem('Chapter 6 Unit Deployment Editor', 'FE1/Chapter6UnitDeploymentEditor'),
  getItem('Chapter 7 Unit Deployment Editor', 'FE1/Chapter7UnitDeploymentEditor'),
  getItem('Chapter 8 Unit Deployment Editor', 'FE1/Chapter8UnitDeploymentEditor'),
  getItem('Chapter 9 Unit Deployment Editor', 'FE1/Chapter9UnitDeploymentEditor'),
  getItem('Chapter Unit Editor', 'FE1/ChapterUnitEditor'),
  getItem('Character editor 1 (FE1) -', 'FE1/Charactereditor1FE1'),
  getItem('Character editor 2 (FE1) -', 'FE1/Charactereditor2FE1'),
  getItem('Character editor 3 (FE1) -', 'FE1/Charactereditor3FE1'),
  getItem('Character editor 4 (FE1) -', 'FE1/Charactereditor4FE1'),
  getItem('Character editor 5 (FE1) -', 'FE1/Charactereditor5FE1'),
  getItem('Character editor 6 (FE1) -', 'FE1/Charactereditor6FE1'),
  getItem('Character editor 7 (FE1) -', 'FE1/Charactereditor7FE1'),
  getItem('Character editor 8 (FE1) -', 'FE1/Charactereditor8FE1'),
  getItem('Character editor 9 (FE1) -', 'FE1/Charactereditor9FE1'),
  getItem('Class Weapon Usablity Pointer Editor', 'FE1/ClassWeaponUsablityPointerEditor'),
  getItem('FE 1 Map pointers editor', 'FE1/Mappointerseditor'),
  getItem('FE1 Chapter 17 Secret Shop Editor', 'FE1/Chapter17SecretShopEditor'),
  getItem('FE1 Chapter 21 Secret Shop Editor', 'FE1/Chapter21SecretShopEditor'),
  getItem('FE1 Chapter 23 Secret Shop Editor', 'FE1/Chapter23SecretShopEditor'),
  getItem('FE1 Chapter 24 Secret Shop Editor', 'FE1/Chapter24SecretShopEditor'),
  getItem('FE1 Class Editor', 'FE1/ClassEditor'),
  getItem('FE1 Growth Rates Editor', 'FE1/GrowthRatesEditor'),
  getItem('FE1 Item Editor', 'FE1/ItemEditor'),
  getItem('FE1 Item Name Editor', 'FE1/ItemNameEditor'),
  getItem('FE1 Item Type Editor', 'FE1/ItemTypeEditor'),
  getItem('FE1 Shop Editor 1', 'FE1/ShopEditor1'),
  getItem('FE1 Shop Editor 2', 'FE1/ShopEditor2'),
  getItem('FE1 Shop Editor 3', 'FE1/ShopEditor3'),
  getItem('FE1 Shop Editor 4', 'FE1/ShopEditor4'),
  getItem('FE1 Shop Editor 5', 'FE1/ShopEditor5'),
  getItem('FE1 Shop Editor 6', 'FE1/ShopEditor6'),
  getItem('FE1 Shop Editor 7', 'FE1/ShopEditor7'),
  getItem('FE1 Shop Editor 8', 'FE1/ShopEditor8'),
  getItem('FE1 Shop Editor 9', 'FE1/ShopEditor9'),
  getItem('FE1 Vendor Editor 1', 'FE1/VendorEditor1'),
  getItem('FE1 Vendor Editor 2', 'FE1/VendorEditor2'),
  getItem('FE1 Vendor Editor 3', 'FE1/VendorEditor3'),
  getItem('FE1 Vendor Editor 4', 'FE1/VendorEditor4'),
  getItem('FE1 Vendor Editor 5', 'FE1/VendorEditor5'),
  getItem('FE1 Vendor Editor 6', 'FE1/VendorEditor6'),
  getItem('FE1 Vendor Editor 7', 'FE1/VendorEditor7'),
  getItem('Promotion Data Table', 'FE1/PromotionDataTable'),
  getItem('Recruitment Editor', 'FE1/RecruitmentEditor'),
  getItem('Weapon Effectiveness Editor', 'FE1/WeaponEffectivenessEditor'),
]);

export default FE1Items;
